<a (click)="switchOnDontAcceptIncomingCalls()"
   *ngIf="!dontAcceptIncomingCalls"
   [class.disabled]="!hasPermissionToSwitchStatus"
   [title]="'USERS.SWITCH_ON_DONT_ACCEPT_INCOMING_CALLS' | translate">
  <div class="accept-incoming-calls"></div>
</a>

<a (click)="switchOffDontAcceptIncomingCalls()"
   *ngIf="dontAcceptIncomingCalls"
   [class.disabled]="!hasPermissionToSwitchStatus"
   [title]="'USERS.SWITCH_OFF_DONT_ACCEPT_INCOMING_CALLS' | translate">
  <div class="dont-accept-incoming-calls"></div>
</a>
